export default "__VITE_ASSET__BrJpcGgm__"